import languages from '../languages';
import { post, STORE_HOST, PASSPORT_HOST, getJSON } from '../ultile';

export const UPDATE_NOW_VALID_ITEM_INDEX = 'updateNowValidItemIndex';
export const GET_SUBSCRIBE = 'getSubscribe';
export const CANCEL_SUBSCRIBE = 'cancelSubscribe';
export const UPDATE_NOW_VALID_ITEM_CANCEL = 'updateNowValidItemCancel';
export const INIT_VALID_LIST = 'initValidList';
export const INIT_EXPIRE_LIST = 'initExpireList';
export const INIT_SUBSCRIBE_LIST = 'initSubscribeList';
export const CHECK_LOGIN_ACTION = 'checkLoginAction';
const CHECK_LOGIN_API = 'center/ajax/get_store_user_json';
languages.init();

const initLanguage = () => {
  return languages.mapMutiples([
    'onestore_subscribe_entrance',
    'onestore_subscribe_manage',
    'onestore_subscribe_has_expire',
    'onestore_subscribe_expire_time',
    'onestore_subscribe_privacy',
    'onestore_subscribe_cancel_subscribe',
    'onestore_subscribe_info_title',
    'onestore_subscribe_option_title',
    'onestore_subscribe_do_not_subscribe',
    'onestore_subscribe_get_role_fail',
    'onestore_subscribe_later',
    'onestore_subscribe_confirm',
    'onestore_subscribe_confirm_cancel',
    'onestore_subscribe_popup_tip',
    'onestore_subscribe_detail_tip',
    'onestore_subscribe_expired_tip',
    'onestore_subscribe_goon_sub',
    'onestore_subscribe_has_cancel_tip1',
    'onestore_subscribe_has_cancel_tip2',
    'onestore_subscribe_cancel_fail',
    'onestore_subscribe_cancel_fail_title',
  ]);
};

export default {
  state: {
    languages: initLanguage(),
    validList: [], //未到期的商品
    expiredList: [], //过期的商品
    nowValidItemIndex: 0,
    privacyLink: `https:${PASSPORT_HOST}center/ServicePrivicy/service`,
  },
  getters: {
    nowValidItemDetail(state) {
      return state.validList.length && state.validList[state.nowValidItemIndex];
    },
  },
  mutations: {
    [INIT_SUBSCRIBE_LIST](state, payload) {
      const IS_EXPIRE_STATUS_MAP = {
        expired: true,
        valid: false,
      };
      Object.keys(IS_EXPIRE_STATUS_MAP).forEach(item => {
        let list = payload[item];
        let subList = state[`${item}List`];
        if (list && list.length) {
          for (let i = 0; i < list.length; i++) {
            while (subList.length) {
              subList.shift();
            }
            for (let i = 0; i < list.length; i++) {
              list[i].isCancel = +list[i].isCancel;
              list[i].isExpire = IS_EXPIRE_STATUS_MAP[item];
              subList.push(list[i]);
            }
          }
        }
      });
    },
    [UPDATE_NOW_VALID_ITEM_INDEX](state, index) {
      state.nowValidItemIndex = index;
    },
    [UPDATE_NOW_VALID_ITEM_CANCEL](state) {
      state.validList[state.nowValidItemIndex].isCancel = 1;
    },
  },
  actions: {
    [GET_SUBSCRIBE]({ commit, state }, params) {
      return new Promise(resolve => {
        post(`${STORE_HOST}one_store/getSubscription`, params).then(
          ({ res }) => {
            if (+res.result === 1) {
              commit(INIT_SUBSCRIBE_LIST, res.data);
            }
            resolve();
          }
        );
      });
    },
    [CANCEL_SUBSCRIBE]({ commit }, params) {
      return new Promise(resolve => {
        post(`${STORE_HOST}one_store/cancelSubscription`, params).then(
          ({ res }) => {
            if (+res.result === 1) {
              commit(UPDATE_NOW_VALID_ITEM_CANCEL);
              resolve({ cancelSucc: true });
            } else {
              resolve({ cancelSucc: false });
            }
          }
        );
      });
    },
    [CHECK_LOGIN_ACTION]({ commit }) {
      return new Promise(resolve => {
        getJSON(PASSPORT_HOST + CHECK_LOGIN_API, {}).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
  },
};
